// extracted by mini-css-extract-plugin
export var active = "_ay-7";
export var container = "_ay-0";
export var evenWidth = "_ay-4";
export var large = "_ay-5";
export var outlet = "_ay-8";
export var slide = "_ay-2";
export var small = "_ay-6";
export var tab = "_ay-3";
export var tabs = "_ay-1";